import { longShortTransform, timeParseNoNull } from "@/_core/_helpers/_helpers";
import { apiService } from "@/_services";

/**
 * Retrieves hedge data for currencies
 * @param {object} _this: context variables
 */
export function getHedgeData(_this) {
  const requestToken = _this.dataLoadToken || 0;
  _this.hedge = [];
  _this.hedge_deleted = [];
  let getPortfolioNumber = [];
  try {
    _this.selectedPortfolios.forEach(function(selectedPortfolio) {
      getPortfolioNumber.push(
        _this.companies[_this.selectedCompany].portfolios[selectedPortfolio.id]
          .pk_idportfolio,
      );
    });
  } catch (error) {
    _this.showLoadingHedge = false;
    console.error("Portfolio list error");
  }

  if (_this.currencySpecs.length === 0) {
    return;
  }
  let getCurrencyNumber = [];
  try {
    for (var crncy in _this.selectedCurrency) {
      getCurrencyNumber.push(
        _this.currencySpecs.filter(
          (curr) => curr.currency_name === _this.selectedCurrency[crncy].name,
        )[0].pk_i_idcurrency,
      );
    }
  } catch (error) {
    _this.showLoadingHedge = false;
    console.error("Currency list error");
  }

  let params = {
    method: "GET",
    endpoint: "currency-hedge",
    content_type: "application/json",
    query_params: {
      format: "json",
      currency: { id_currencies: getCurrencyNumber },
      portfolios: { id_portfolios: getPortfolioNumber },
    },
  };
  apiService
    .getAll(params)
    .then((data) => {
      if (requestToken !== (_this.dataLoadToken || 0)) return;
      data = JSON.parse(JSON.stringify(data));
      data.forEach(function(d) {
        d.pk =
          _this.companies[_this.selectedCompany].company_name
            .split(/\s/)
            .reduce((response, word) => (response += word.slice(0, 1)), "") +
          d.pk_idcurrencyhedge;
        d.trade_date = timeParseNoNull(d.trade_date);
        d.fixing_date = timeParseNoNull(d.fixing_date);
        d.value_date = timeParseNoNull(d.value_date);
        d.premium_value_date = timeParseNoNull(d.premium_value_date);
        d.asian_fixing_start_date = timeParseNoNull(d.asian_fixing_start_date);
        d.hedged_date = timeParseNoNull(d.hedged_date);
        d.sale_date = timeParseNoNull(d.sale_date);
        d.shipping_date = timeParseNoNull(d.shipping_date);
        d.buy_sell = longShortTransform(d.buy_sell.toUpperCase());
        d.derivative = d.derivative.toUpperCase();
        d.settlement_type = d.settlement_type.replace("_", " ").toUpperCase();
        d.fk_idcurrencystrategy_derivative = d.fk_idcurrencystrategy_derivative.toUpperCase();
        d.strategy_position = d.fk_idcurrencystrategy_derivative.substr(
          0,
          d.fk_idcurrencystrategy_derivative.indexOf(" "),
        );
        d.strategy_name = d.fk_idcurrencystrategy_derivative.substr(
          d.fk_idcurrencystrategy_derivative.indexOf(" ") + 1,
        );
        d.fk_idoptiontype = _this.optionTypes[d.fk_idoptiontype - 1].name;
      });
      _this.hedge = data;
      _this.showLoadingHedge = false;
      _this.dataSavedHedge = true;
      _this.saveLegendHedge = "Saved:";
      _this.refreshLegendHedge = "Synced:";
    })
    .catch(function(error) {
      if (requestToken !== (_this.dataLoadToken || 0)) return;
      _this.showLoadingHedge = false;
      _this.dataSavedHedge = true;
      _this.saveLegendHedge = "Saved:";
      _this.refreshLegendHedge = "Synced:";
      console.error(error);
    });
}
